import { render, staticRenderFns } from "./ConsigneEditor.vue?vue&type=template&id=0f2030c6"
import script from "./ConsigneEditor.vue?vue&type=script&lang=js"
export * from "./ConsigneEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports